import {store} from "../store";
import {clearChannelView} from "../helpers/clearedChannels";

export function input(): boolean {
	if (store.state.activeChannel) {
		clearChannelView(store.state.activeChannel.channel);
	}

	return true;
}
